<template>
  <div class="border-b-2 border-grey-200 py-6">
    <Container>
      <div class="flex gap-y-8 py-14 gap-x-default max-lg:flex-col">
        <!-- FIELD OF APPLICATION -->
        <div class="flex-1 lg:max-w-144 max-sm:w-full sm:min-w-96">
          <label class="mb-1.5 block text-grey-300 typo-subtitle" for="headlessui-listbox-button-field-of-application">{{ $t('field_of_application') }}</label>
          <SingleSelect
            title="field-of-application-filter-language"
            :model-value="fieldsOfApplication.find((fieldOfApplication) => fieldOfApplication?.slug === filter?.field_of_application) || undefined"
            placeholder="auswählen"
            :options="fieldsOfApplication || []"
            variant="gray"
            size="lg"
            @update:model-value="filter ? filter.field_of_application = $event.slug : null"
          />
        </div>
        <!-- SEARCH -->
        <div class="max-w-144 flex-1">
          <label class="mb-1.5 block text-grey-300 typo-subtitle" for="download-search">{{ $t('search_dl_center') }}</label>
          <SearchInput
            id="downlaod-search"
            :value="filter ? filter.searchTerm : ''"

            @input="filter ? filter.searchTerm = $event : ''"
          />
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
import type { CleaningMethodFilterType } from '~/components/main-components/OverviewCleaningMethods.vue'

withDefaults(
  defineProps<{
    fieldsOfApplication: Array<{
      id: string
      slug: string
      title: string
    }>
  }>(),
  {
    fieldsOfApplication: () => [],
  },
)
const filter = defineModel<CleaningMethodFilterType>()
</script>
